<template>
  <div class="centerBox">
    <!-- $store.state.isPage ==
    1代表授权登录的回调地址是首页，所以需要展示首页占位骨架屏
    $store.state.isPage ==
    2代表授权登录的回调地址是详情页，所以需要展示详情页占位骨架屏 -->
    <!-- 详情页占位 -->
    <div class="isDetailNot" v-if="$store.state.isPage == 2">
      <div class="BoxHead2">
        <div class="headLeft">
          <!-- 返回按钮 -->
          <div class="leftJt">
            <svg-btn class="leftIcon" icon-class="icon-left"></svg-btn>
          </div>
          <!-- logo -->
          <div class="skeleton-avatar"></div>
          <!-- 用户信息 -->
          <div class="info">
            <div class="skeleton-name"></div>
            <div class="skeleton-fans"></div>
          </div>
        </div>
        <div class="headright">
          <div class="skeleton-bt"></div>
          <div class="moreBox">
            <svg-btn class="more" icon-class="icon-gfans-more"></svg-btn>
          </div>
        </div>
      </div>
      <!-- 主体内容 -->
      <div class="content">
        <!-- 标题 -->
        <div class="skeleton-title"></div>
        <!-- 时间和关联标签 -->
        <div class="timeTabBox">
          <div class="skeleton-time"></div>
          <div class="skeleton-time"></div>
          <div class="skeleton-time"></div>
        </div>
        <div class="skeleton-html"></div>
        <div class="naturalBox">
          <div class="natural" v-for="(item, index) in 4" :key="index">
            <div class="leftBox">
              <!-- 资源图标 -->
              <div class="skeleton-leftIcon"></div>
              <div class="rightInfo">
                <!-- 资源名称和按钮 -->
                <div class="skeleton-text1"></div>
                <div class="skeleton-text2"></div>
              </div>
            </div>
            <div class="skeleton-rightBt"></div>
          </div>
        </div>
      </div>
      <!-- 评论内容 -->
      <div class="comment" style="padding-bottom: 0">
        <!-- 评论头部 -->
        <div class="commentHead">
          <div class="headLeft">
            <div class="skeleton-cfont1"></div>
          </div>
          <div class="headRight">
            <div class="skeleton-cfont1"></div>
            <div class="skeleton-cfont1"></div>
          </div>
        </div>
        <!-- 评论输入框 -->
        <div class="commitInputBox">
          <div class="leftInput">
            <div class="skeleton-headImg"></div>
          </div>
          <div class="skeleton-Input"></div>
          <div class="skeleton-bt2"></div>
        </div>
        <!-- 空状态 -->
        <div class="noneData">
          <div class="skeleton-noneIcon"></div>
          <div class="skeleton-font2"></div>
        </div>
      </div>
      <!-- 底部悬浮按钮 -->
      <div class="bottomBox">
        <!-- 分享按钮 -->
        <div class="bottom">
          <svg-btn class="icon" icon-class="icon-share"></svg-btn>
        </div>
        <!-- 点赞按钮 -->
        <div class="bottom">
          <svg-btn class="icon" icon-class="icon-up"></svg-btn>
        </div>
        <!-- 收藏按钮 -->
        <div class="bottom">
          <svg-btn class="icon" icon-class="icon-collect"></svg-btn>
        </div>
        <!-- 评论按钮 -->
        <div class="bottom">
          <svg-btn class="icon" icon-class="icon-comment"></svg-btn>
        </div>
      </div>
    </div>
    <!-- 订阅首页占位 -->
    <div class="BoxHead" v-if="$store.state.isPage == 1">
      <TabCheck :defaultActive="defaultActive" :tabs="tabs" />
    </div>
    <div class="skeleton-container" v-if="$store.state.isPage == 1">
      <div class="skeleton-item" v-for="i in 3" :key="i">
        <div class="skeleton-head">
          <div class="skeleton-avatar"></div>
          <div class="skeleton-info">
            <div class="skeleton-line line-1"></div>
            <div class="skeleton-line line-2"></div>
          </div>
        </div>
        <div class="skeleton-title"></div>
        <div class="skeleton-image"></div>
        <div class="skeleton-desc"></div>
        <div class="skeleton-actions">
          <div class="skeleton-btn"></div>
          <div class="skeleton-btn"></div>
          <div class="skeleton-btn"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FmContent from '@/components/FmContent/index'
import TabCheck from '@/components/TabCheck/index'
export default {
  components: {
    FmContent,
    TabCheck,
  },
  props: {},
  data() {
    return {
      tabs: [
        { id: 0, name: '我的订阅' },
        { id: 1, name: '发现' },
      ],
      defaultActive: 1,
    }
  },
  mounted() {},
  beforeDestroy() {},
  created() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.centerBox {
  margin-top: -72px;
  .BoxHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 400;
    height: 72px;
    min-height: 72px;
    max-width: 600px;
    width: 100%;
  }
  @media (max-width: 1100px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 500px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于700px时 */
  @media (max-width: 700px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 420px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于600px时 */
  @media (max-width: 600px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 350px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于550px时 */
  @media (max-width: 550px) {
    .BoxHead {
      width: calc(100% - 600px);
      min-width: 250px;
      max-width: 100%;
    }
  }
  .BoxHead2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // position: fixed;
    position: sticky;
    top: 0;
    z-index: 400;
    height: 72px;
    min-height: 72px;
    max-width: 600px;
    width: 100%;
    .headLeft {
      display: flex;
      align-items: center;
      margin-right: 16px;
      .avatar-container {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
      }

      .headImg {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 50%;
        flex-shrink: 0;
      }

      .info {
        display: flex;
        flex-direction: column;
        margin-left: 12px;
        max-width: 367px;

        .font1 {
          font-weight: 500;
          font-size: 14px;
          line-height: 22px;
          max-width: 367px;
          min-width: 75px;
          @include multiline(1);
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }

        .font2 {
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          @include multiline(1);
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
        }
      }
      .leftJt {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-right: 12px;
        @include useTheme {
          color: getVar('text-color1-2c2c2c');
        }
        .leftIcon {
          width: 18px;
          height: 18px;
        }
        &:hover {
          @include useTheme {
            background: getVar('bg-color1-f4f6f8');
          }
        }
      }
    }
    .headright {
      display: flex;
      align-items: center;
      .moreBox {
        cursor: pointer;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        @include useTheme {
          color: getVar('text-color7-90969c');
        }
        .more {
          width: 16px;
          height: 16px;
        }
        &:hover {
          @include useTheme {
            background: getVar('bg-color1-f4f6f8');
          }
        }
      }
      .releaseBtn {
        padding: 5px 23px;
        height: 32px;
        border-radius: 18px;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 22px;
        margin-right: 16px;
        flex-shrink: 0;
      }
      .releaseBtn2 {
        padding: 0 !important;
        width: 74px !important;
        @include useTheme {
          color: getVar('text-color1-2c2c2c') !important;
        }
      }
      .textBtn {
        background: transparent !important;
      }
    }
  }
  @media (max-width: 1100px) {
    .BoxHead2 {
      width: calc(100% - 600px);
      min-width: 400px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于700px时 */
  @media (max-width: 700px) {
    .BoxHead2 {
      width: calc(100% - 600px);
      min-width: 320px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于600px时 */
  @media (max-width: 600px) {
    .BoxHead2 {
      width: calc(100% - 600px);
      min-width: 300px;
      max-width: 100%;
    }
  }
  /* 当屏幕宽度小于等于550px时 */
  @media (max-width: 550px) {
    .BoxHead2 {
      width: calc(100% - 600px);
      min-width: 150px;
      max-width: 100%;
      .headLeft {
        .info {
          margin-left: 0;
        }
        .leftJt {
          margin-right: 5px;
        }
      }
      .headright {
        .releaseBtn {
          margin-right: 5px;
        }
      }
      .headImg {
        display: none;
      }
    }
  }
  @media (max-width: 451px) {
    .BoxHead2 {
      width: calc(100% - 600px);
      min-width: 150px;
      max-width: 100%;
      .headLeft {
        .info {
          margin-left: 0;
        }
        .leftJt {
          margin-right: 5px;
        }
      }
      .headright {
        .releaseBtn {
          margin-right: 5px;
        }
      }
      .headImg {
        display: none;
      }
    }
  }
  .content {
    padding: 16px 16px 24px 16px;
    border-radius: 16px 16px 0px 0px;
    @include useTheme {
      background: getVar('bg-color-content');
      box-shadow: inset 0px -1px 0px 0px getVar('border-color2-f2f4f6');
    }
    .title {
      font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      margin-bottom: 14px;
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
      }
    }
    .timeTabBox {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 16px;

      .time {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        margin-right: 12px;
        @include multiline(1);
        @include useTheme {
          color: getVar('text-color3-90969c');
        }
      }
      .tabBox {
        display: flex;
        .tab {
          padding: 0 4px;
          height: 16px;
          border-radius: 3px;
          margin-right: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          @include useTheme {
            border: 1px solid getVar('primary-color');
          }
          &:last-child {
            margin-right: 0;
          }
          .tabFont {
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            @include multiline(1);
            @include useTheme {
              color: getVar('primary-color');
            }
          }
        }
      }
    }
    ::v-deep .videoBox {
      width: 100%;
      height: 338px;
      margin-bottom: 16px;
      position: relative;
      .video-container {
        width: 100%;
        height: 100%;
      }
      /* 弹幕开关样式 */
      .danmuku-toggle {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 100;
        transition: all 0.3s;

        &:hover {
          background-color: rgba(5, 216, 196, 0.8);
        }

        .danmuku-icon {
          width: 24px;
          height: 24px;
          color: white;
        }
      }
      .apd-config {
        display: none !important;
      }
      .apd-emitter {
        display: none !important;
      }
      .artplayer-plugin-danmuku {
        position: relative !important;
        justify-content: flex-end !important;
      }
    }
    .imgHtmlBox {
      display: flex;
      flex-direction: column;
      position: relative;
      .clickMore {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 160px;
        position: absolute;
        width: 100%;
        bottom: 0;
        cursor: pointer;
        @include useTheme {
          background: linear-gradient(
            180deg,
            getVar('bg-color7-1') 0%,
            getVar('bg-color7-2') 24%,
            getVar('bg-color7-3') 56%,
            getVar('bg-color-content') 100%,
            getVar('bg-color-content') 100%
          );
        }
        .morea {
          font-weight: 500;
          font-size: 14px;
          line-height: 22px;
          margin-right: 6px;
          @include useTheme {
            color: getVar('primary-color');
          }
        }
        .bottomIcon {
          width: 16px;
          height: 16px;
          @include useTheme {
            color: getVar('primary-color');
          }
        }
      }
    }
    .naturalBox {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-top: 4px;
      width: 100%;
      .natural {
        width: 100%;
        padding: 8px 16px 8px 12px;
        height: 52px;
        border-radius: 10px;
        margin-bottom: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include useTheme {
          border: 1px solid getVar('border-color2-f2f4f6');
          background: getVar('bg-color8-f9f9f9');
        }
        &:last-child {
          margin-bottom: 0;
        }
        .leftBox {
          display: flex;
          align-items: center;
          .leftIcon {
            width: 24px;
            height: 24px;
            @include useTheme {
              color: getVar('text-color1-2c2c2c');
            }
          }
          .rightInfo {
            margin-left: 12px;
            .text1 {
              max-width: 382px;
              font-weight: 600;
              font-size: 12px;
              line-height: 18px;
              @include multiline(1);
              @include useTheme {
                color: getVar('text-color1-2c2c2c');
              }
            }
            .text2 {
              font-weight: 400;
              font-size: 12px;
              line-height: 18px;
              @include useTheme {
                color: getVar('text-color3-90969c');
              }
            }
          }
        }
        .rightBt {
          min-width: 94px;
          max-width: 94px;
          height: 28px;
          border-radius: 18px;
          font-weight: 500;
          font-size: 12px;
          color: #ffffff;
          line-height: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin-left: 32px;
        }
      }
    }
    .checkBox {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 16px;
      .cBox {
        display: flex;
        align-items: center;
        cursor: pointer;
        .checkIcon {
          width: 14px;
          height: 14px;
          @include useTheme {
            color: getVar('border-color4-e5e5e5');
          }
        }
        .checkIcon2 {
          @include useTheme {
            color: getVar('primary-color') !important;
          }
        }
        .checkFont {
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          margin-left: 9px;
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }
      }
    }
    .imgBox {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 16px;
      .img {
        width: 100%;
        max-width: 100%;
        height: auto;
        border-radius: 16px;
        margin-bottom: 16px;
      }
    }
  }
  .comment {
    padding: 20px 0;
    flex-grow: 1;
    @include useTheme {
      background: getVar('bg-color-content');
    }
    .commentHead {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      margin-bottom: 24px;
      white-space: nowrap;
      .headLeft {
        display: flex;
        justify-content: center;
        align-items: center;
        .cfont1 {
          font-weight: 600;
          font-size: 14px;
          line-height: 22px;
          margin-right: 8px;
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }
        .cfont2 {
          font-weight: 600;
          font-size: 12px;
          line-height: 18px;
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
        }
      }
      .headRight {
        display: flex;
        align-items: center;
        ::v-deep .click-pop {
          .click-pop-box {
            top: 40px !important;
          }
        }
        .oneRight {
          display: flex;
          align-items: center;
          cursor: pointer;
          .oneIcon {
            width: 16px;
            height: 16px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
          }
          .oneIcon2 {
            @include useTheme {
              color: getVar('primary-color') !important;
            }
          }
          .cfont3 {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            margin-left: 4px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
          }
          .cfont3A {
            @include useTheme {
              color: getVar('primary-color') !important;
            }
          }
        }
        .line {
          width: 1px;
          height: 12px;
          margin: 0 8px;
          @include useTheme {
            background: getVar('border-color2-f2f4f6');
          }
        }
        .twoRight {
          padding: 7px 20px;
          max-width: 88px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 18px;
          cursor: pointer;
          white-space: nowrap;
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
          .twoIcon {
            width: 16px;
            height: 16px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
          }
          .cfont3 {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            margin-left: 4px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
          }
          &:hover {
            @include useTheme {
              background: getVar('bg-color1-f4f6f8');
            }
          }
        }
      }
    }
    .commitInputBox {
      display: flex;
      align-items: flex-start;
      padding: 0 16px;
      // align-items: center;
      .leftInput {
        height: 48px;
        .headImg {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          object-fit: cover;
        }
      }
      .Input {
        flex: 1;
        margin: 0 12px;
        position: relative;
        .inputIcon {
          width: 20px;
          height: 20px;
          position: absolute;
          left: 16px;
          top: 15px;
          @include useTheme {
            color: getVar('text-color6-b8bec4');
          }
        }
      }
      .rightInput {
        margin-top: 4px;
        padding: 8px 24px;
        height: 40px;
        border-radius: 20px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        flex-shrink: 0;
      }
    }
    .commitContent {
      display: flex;
      flex-direction: column;
      margin-top: 24px;
      .commitBox {
        display: flex;
        flex-direction: column;
        padding: 8px 0;
        .authorBox {
          margin-left: 6px;
          border-radius: 13px;
          padding: 0 6px;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          flex-shrink: 0;
          @include useTheme {
            color: getVar('text-color7-90969c');
            background: getVar('bg-color1-f4f6f8');
          }
        }
        .topBox {
          margin-left: 6px;
          background: #f67942;
          border-radius: 13px;
          padding: 0 6px;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 18px;
          flex-shrink: 0;
        }
        .oneCommit {
          display: flex;
          flex-direction: column;
          padding: 8px 16px;
          .leftC {
            display: flex;
            align-items: flex-start;
          }
          .twoInput {
            padding-left: 56px;
          }
        }
        .twoCommit {
          display: flex;
          flex-direction: column;
        }
        .twoInput {
          display: flex;
          align-items: center;
          // padding-left: 72px;
          margin-top: 8px;
          .rightInput {
            margin-top: 4px;
            padding: 8px 24px;
            height: 40px;
            border-radius: 20px;
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            line-height: 24px;
            flex-shrink: 0;
            margin-left: 12px;
          }
        }
        .twoMore {
          margin-top: 4px;
          padding-left: 72px;
          white-space: nowrap;
          display: flex;
          justify-content: flex-start;
          .twoMoreFont {
            cursor: pointer;
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            @include useTheme {
              color: getVar('primary-color');
            }
          }
        }
        .headImg {
          width: 48px;
          height: 48px;
          object-fit: cover;
          border-radius: 50%;
        }
        .rightCommit {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          margin-left: 12px;
          flex: 1;
          ::v-deep .click-pop {
            .click-pop-box {
              top: 28px !important;
            }
          }
          .commitFont1 {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 2px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            line-height: 22px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
            .fontLeft {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .commitFont2 {
            max-width: 508px;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 10px;
            // @include multiline(1);
            word-wrap: break-word;
            word-break: normal;
            @include useTheme {
              color: getVar('text-color1-2c2c2c');
            }
          }
          .commitFont3 {
            display: flex;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            @include useTheme {
              color: getVar('text-color3-90969c');
            }
          }
          .commitFont4 {
            cursor: pointer;
            margin-left: 20px;
          }
        }
        .commitChild {
          display: flex;
          flex-direction: column;
          padding: 8px 16px 8px 72px;
          .leftC {
            display: flex;
            align-items: flex-start;
          }
          .childImg {
            width: 34px;
            height: 34px;
            object-fit: cover;
            border-radius: 50%;
          }
          .childCommitBox {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            margin-left: 12px;
            flex: 1;
            .commitB {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            }
            .commitFont4 {
              font-weight: 500;
              font-size: 14px;
              line-height: 22px;
              margin-bottom: 2px;
              display: flex;
              align-items: center;
              justify-content: center;
              @include useTheme {
                color: getVar('text-color3-90969c');
              }
              .commitText {
                @include multiline(1);
              }
              .replyFont {
                font-weight: 400;
                font-size: 14px;
                line-height: 22px;
                margin: 0 6px;
                flex-shrink: 0;
                @include useTheme {
                  color: getVar('text-color1-2c2c2c');
                }
              }
            }
            .commitFont5 {
              font-weight: 400;
              font-size: 14px;
              line-height: 22px;
              margin-bottom: 10px;
              @include useTheme {
                color: getVar('text-color1-2c2c2c');
              }
            }
            .commitFont6 {
              font-weight: 400;
              font-size: 12px;
              line-height: 18px;
              display: flex;
              align-items: center;
              justify-content: center;
              @include useTheme {
                color: getVar('text-color3-90969c');
              }
            }
            .commitFont7 {
              margin-left: 20px;
              cursor: pointer;
            }
          }
        }
      }
    }
    .moreCommit {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 32px;
      .more {
        max-width: 320px;
        height: 40px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        flex: 1;
        cursor: pointer;
        @include useTheme {
          background: getVar('bg-color1-f4f6f8');
          color: getVar('text-color1-2c2c2c');
        }
      }
      .not {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        @include useTheme {
          color: getVar('text-color6-b8bec4');
        }
      }
    }
    .loadStatus {
      padding: 16px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .loadBox {
        display: flex;
        align-items: center;
        justify-content: center;
        .spinner {
          border: 3px solid rgba(5, 216, 196, 0.2);
          border-radius: 50%;
          width: 18px;
          height: 18px;
          animation: spin 1s linear infinite;
          margin-right: 10px;
          @include useTheme {
            border-top: 3px solid getVar('primary-color');
          }
        }
      }
      .not {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        @include useTheme {
          color: getVar('text-color3-90969c');
        }
      }
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .commitBg {
      @include useTheme {
        background: getVar('bg-color9-e6fbf9');
      }
    }
    .noneData {
      padding-top: 72px;
      padding-bottom: 120px;
      height: auto !important;
    }
    .moreBox {
      cursor: pointer;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      @include useTheme {
        color: getVar('text-color7-90969c');
      }
      .more {
        width: 16px;
        height: 16px;
      }
      &:hover {
        @include useTheme {
          background: getVar('bg-color1-f4f6f8');
        }
      }
    }
  }
  ::v-deep .commitInput {
    margin-top: 4px;
    .el-textarea__inner {
      min-height: 40px; /* 设置最小高度 */
      max-height: 106px;
      border-radius: 20px;
      padding: 9px 16px 9px 16px !important;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      border: 1px solid transparent;
      white-space: pre-wrap;
      word-break: break-all;
      overflow-y: auto !important;
      // transition: padding-left 0.2s;
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
        caret-color: getVar('primary-color');
        background: getVar('bg-color14-f4f6f8');
      }
      &::placeholder {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        @include useTheme {
          color: getVar('text-color6-b8bec4');
        }
      }
      &:hover {
        @include useTheme {
          border: 1px solid getVar('primary-color');
        }
      }
      &:focus {
        transition: padding-left 0.2s;
        padding-left: 16px;
        @include useTheme {
          outline: 2px solid getVar('primary-color4');
          border: 1px solid getVar('primary-color');
          background: getVar('bg-color-content');
        }
      }
    }
  }
  ::v-deep .textInput {
    .el-textarea__inner {
      padding: 9px 16px 9px 44px !important;
    }
  }
  .bottomBox {
    z-index: 100;
    padding: 6px 16px;
    position: sticky;
    bottom: 0;
    display: flex;
    align-items: center;
    // max-width: 600px;
    width: 100%;
    @include useTheme {
      background: getVar('bg-color-content');
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 142px;
      height: 52px;
      cursor: pointer;
      .icon {
        width: 20px;
        height: 20px;
        @include useTheme {
          color: getVar('text-color2-75787b');
        }
      }
      .icon2 {
        @include useTheme {
          color: getVar('primary-color') !important;
        }
      }
      .bottomFont {
        font-weight: 500;
        font-size: 13px;
        line-height: 18px;
        margin-left: 6px;
        @include multiline(1);
        @include useTheme {
          color: getVar('text-color2-75787b');
        }
      }
      .bottomFont2 {
        @include useTheme {
          color: getVar('primary-color');
        }
      }
    }
  }
  // 骨架屏样式
  .isDetailNot {
    display: flex;
    flex-direction: column;
    height: 100%;
    .skeleton-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-name {
      height: 20px;
      width: 75px;
      margin-bottom: 2px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-fans {
      width: 50px;
      height: 18px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-bt {
      width: 74px !important;
      height: 32px;
      border-radius: 18px;
      margin-right: 16px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-title {
      width: 50%;
      height: 26px;
      margin-bottom: 14px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-time {
      width: 10%;
      height: 18px;
      margin-right: 12px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-html {
      width: 100%;
      height: 338px;
      border-radius: 16px;
      margin-bottom: 16px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-leftIcon {
      width: 24px;
      height: 24px;
      border-radius: 5px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-text1 {
      max-width: 382px;
      min-width: 100px;
      height: 16px;
      margin-bottom: 4px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-text2 {
      max-width: 382px;
      min-width: 50px;
      height: 16px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-rightBt {
      min-width: 94px;
      max-width: 94px;
      height: 28px;
      border-radius: 18px;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-left: 32px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-cfont1 {
      width: 50px;
      height: 22px;
      margin-right: 8px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-headImg {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-Input {
      flex: 1;
      margin: 0 12px;
      margin-top: 4px;
      min-height: 40px;
      max-height: 106px;
      border-radius: 20px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-bt2 {
      margin-top: 4px;
      width: 80px;
      height: 40px;
      border-radius: 20px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-noneIcon {
      width: 100px;
      height: 100px;
      margin-bottom: 24px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      border-radius: 10px;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    .skeleton-font2 {
      width: 80px;
      height: 22px;
      animation: pulse 1.5s 0.3s infinite ease-in-out;
      @include useTheme {
        background: getVar('bg-color1-f4f6f8');
      }
    }
    @keyframes pulse {
      0%,
      100% {
        opacity: 1;
      }
      50% {
        opacity: 0.8;
      }
    }
  }
  /* 骨架屏样式 */
  .skeleton-container {
    height: 100%;
    border-radius: 16px 16px 0px 0px;
    @include useTheme {
      background: getVar('bg-color-content');
    }
  }

  .skeleton-item {
    border-radius: 16px;
    margin-bottom: 16px;
    padding: 16px;
    @include useTheme {
      background: getVar('bg-color-content');
    }
    &:nth-child(even) {
      animation: pulse 1.5s infinite ease-in-out;
    }

    &:nth-child(odd) {
      animation: pulse 1.5s 0.3s infinite ease-in-out;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  .skeleton-head {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .skeleton-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-info {
    margin-left: 12px;
    flex: 1;
  }

  .skeleton-line {
    height: 16px;
    border-radius: 8px;
    margin-bottom: 6px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .line-1 {
    width: 60%;
  }

  .line-2 {
    width: 40%;
  }

  .skeleton-title {
    height: 24px;
    border-radius: 12px;
    margin-bottom: 12px;
    width: 80%;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-image {
    height: 150px;
    border-radius: 16px;
    margin-bottom: 12px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-desc {
    height: 42px;
    border-radius: 8px;
    margin-bottom: 16px;
    width: 90%;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  .skeleton-actions {
    display: flex;
    justify-content: space-around;
  }

  .skeleton-btn {
    width: 80px;
    height: 32px;
    border-radius: 16px;
    @include useTheme {
      background: getVar('bg-color1-f4f6f8');
    }
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
  }
}
</style>
